<template>
  <div>
      <el-menu default-active="2"
      :router="isMenuAsRouter"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :default-active="currentPath"
      background-color="transparent"
      >
        <span v-for="menu in menus">
          <sidebaritem v-bind:sbi="menu" v-bind:index="menu.label"></sidebaritem>
        </span>
      </el-menu>
      <div class="menu-loading" v-loading.body="loading"></div>
    </div>
  </template>

  <script>
  import config from '../../appsettings.js'
  import sidebaritem from './sidebaritem.vue'

  export default {
    name: 'sidebar',
    data() {
      return {
        isMenuAsRouter: true,
        prefix: config.API_PREFIX,
        menus: [],
        loading: true
      }
    },
    components: { sidebaritem },
    computed: {
      currentPath: function () {
        return this.$route.path;
      }
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      showDoc() {
        this.loading = false;
      },
      fetchData() {
        let self = this;
        this.$gf.getOptions().then(options => {
          options.params = {};
          self.loading = true;
          self.$http.get(`${self.prefix}menu`, options).
          then(response => {
            self.menus = response.data;
            self.loading = false;
          }).catch(data => {
            self.loading = false;
            self.$gf.checkError(data);
          })
        }).catch(err => {
           self.loading = false;
           this.$gf.catchOptions();
         });
      }
    },
    created: function () {
      Event.$on('stayOnResume', () => {
        //TODO: highlight
      });
      Event.$on('onDocIsShown', () => this.showDoc());
      this.fetchData();
    },
    beforeDestroy: function() {
      Event.$off('stayOnResume');
      Event.$off('onDocIsShown');
    }
  }
</script>

<style scoped>
  .menu-loading {
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar.vue